import { action, observable, autorun } from 'mobx';
import Cookies from 'js-cookie';
import axios from 'axios';

import { isString, isBoolean } from '~/common/utils/typeCheckers';
import { appsFlyerDeviceType, appsFlyerDeviceId, utmCampaign } from '~/common/globals';
import { RUBY_LEAD_PROGRAM } from '~/common/utils/consts';

class ProductTrackingClass {
    @observable deviceType = '';
    @observable deviceID = '';
    @observable isRubySignup = false;

    constructor() {
        autorun((reaction) => {
            if (decodeURI(appsFlyerDeviceId()) && decodeURI(appsFlyerDeviceId()) !== 'false') {
                // set preselected number if available
                this.setDeviceID(decodeURI(appsFlyerDeviceId()));
                reaction.dispose();
            }
        });

        autorun((reaction) => {
            if (decodeURI(appsFlyerDeviceType()) && decodeURI(appsFlyerDeviceType()) !== 'false') {
                // set preselected number if available
                this.setDeviceType(decodeURI(appsFlyerDeviceType()));
                reaction.dispose();
            }
        });

        autorun((reaction) => {
            // if utm campaign originated from ruby
            const rubySignup = (decodeURI(utmCampaign()) && decodeURI(utmCampaign()) === '848255') || Cookies.get('gh_utm-campaign') === 'true';
            if (rubySignup) {
                // set preselected number if available
                this.setIsRubySignup(rubySignup);
                Cookies.remove('gh_utm-campaign');
                reaction.dispose();
            }
        });
    }

    @action setDeviceType(string) {
        if (string === 'false') return;
        this.deviceType = isString(string, this.deviceType);
    }

    @action setDeviceID(string) {
        if (string === 'false') return;
        this.deviceID = isString(string, this.deviceID);
    }

    @action setIsRubySignup(bool) {
        if (bool === false) return;
        this.isRubySignup = isBoolean(bool, this.isRubySignup);
    }

    // makes an axios request to post an email to endpoint
    @action sendIsRubySignup(email) {
        if (!email) throw Error('no email was passed');

        const preparedEmail = {
            email,
            program: RUBY_LEAD_PROGRAM,
            success: false,
            mkto_trk: Cookies.get('_mkto_trk') || ''
        };

        axios.post('/api/proxy/capture-emails', preparedEmail).catch((err) => {
            return err;
        });
    }
}

const productTrackingStore = new ProductTrackingClass();
export { productTrackingStore, ProductTrackingClass };
